import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import AdditionalInfo from './BusinessTimeInfo'
import AutoIdSVGLight from '../../assets/icons/pi_autoid.svg';
import AutoIdSVGDark from '../../assets/icons/pi_autoid_dark.svg';
import EidSVGLight from '../../assets/icons/pi_eid_light.svg';
import EidSVGDark from '../../assets/icons/pi_eid_dark.svg';
import BasicSVGLight from '../../assets/icons/pi_basic.svg';
import BasicSVGDark from '../../assets/icons/pi_basic_dark.svg';
import EudiwSVGLight from '../../assets/icons/pi_eudiw_light.svg';
import EudiwSVGDark from '../../assets/icons/pi_eudiw_dark.svg';
import VideoSVGLight from '../../assets/icons/pi_video.svg';
import VideoSVGDark from '../../assets/icons/pi_video_dark.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon.svg';
import { ReactComponent as DeactivatedMethodIcon } from '../../assets/icons/method-deactivated.svg';
import './Method.scss'
import {getServiceCenterInfo} from "../../lib/emmiApi";


export function CustomLink(props) {
    const {enabled, ...rest} = props;
    return enabled ? <Link {...rest}>{props.children}</Link> : <div {...rest}>{props.children}</div>;
}

CustomLink.propTypes = {
    enabled: PropTypes.bool,
    children: PropTypes.node.isRequired
};

export function getLocoAsSVG(enabled, method){
    switch (method) {
        case "autoid":
            return <div data-test-id={'59290177-1ff6-' + method}>
            <img src={AutoIdSVGLight} className="light-img" alt=""/>
            <img src={AutoIdSVGDark} className="dark-img" alt=""/></div>
        case "eid":
            return <div data-test-id={'59290177-1ff6-' + method}>
                <img src={EidSVGLight} className="light-img" alt=""/>
                <img src={EidSVGDark} className="dark-img" alt=""/></div>
        case "video":
            return <div data-test-id={'59290177-1ff6-' + method}>
                <img src={VideoSVGLight} className="light-img" alt=""/>
                <img src={VideoSVGDark} className="dark-img" alt=""/></div>
        case "basic":
            return <div data-test-id={'59290177-1ff6-' + method}>
                <img src={BasicSVGLight} className="light-img" alt=""/>
                <img src={BasicSVGDark} className="dark-img" alt=""/></div>
        case "eudiwid":
            return <div data-test-id={'59290177-1ff6-' + method}>
                <img src={EudiwSVGLight} className="light-img" alt=""/>
                <img src={EudiwSVGDark} className="dark-img" alt=""/></div>
        default: return null;
    }
}

export function Method({
                           method,
                           heading,
                           subHeading,
                           queryParams,
                           info,
                           category,
                           enabled,
                           disabledInfo,
                           onClickCallback
                       }) {
    const [serviceCenterInfo, setServiceCenterInfo] = useState({})

    useEffect(() => {
        if (category) {
            getServiceCenterInfo(category)
                .then(setServiceCenterInfo)
                .catch()
        }
    }, [category])

    return <CustomLink
        enabled={enabled} to={{pathname: '/' + method, search: queryParams}}
        method={method} className={'dpag-method card px-3 py-3 mb-1 ' + (enabled?"enabled":"disabled")} data-test-id={'38b62df6-b5d5-' + method}
        onClick={() => {
            onClickCallback(method, enabled)
        }}
        >
        <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-3 col-4 d-flex flex-wrap align-content-center">
                {getLocoAsSVG(enabled, method)}
            </div>
            <div className="col-lg-9 col-md-9 col-sm-9 col-8 media-body align-self-center pl-3 pr-2">
                <div className="row">
                    <div className="col-9">
                        <h2 className={'font-weight-bold heading m-0 ' + (enabled ? "enabled" : "disabled")}
                            data-test-id={'9711df18-403e-' + method}>{heading}</h2>
                    </div>
                    <div className="col-3 text-end">
                        {enabled ? "" : <DeactivatedMethodIcon className="method-deactivated-icon"/>
                        }
                    </div>
                </div>
                <p className={'subheading color-text text-muted ' + (enabled ? "enabled" : "disabled")}
                   data-test-id={'14c87da7-526c-' + method} dangerouslySetInnerHTML={{__html: subHeading}}>
                </p>
                <AdditionalInfo info={disabledInfo}/>
            </div>
            <div className="col-12 businessTime">
                <div className="col-xl-9 d-flex justify-content-end align-items-center">
                    <small data-test-id="bf766297-4454">{info}</small>
                    <AdditionalInfo info={serviceCenterInfo.businessTime}/>
                    {(info || serviceCenterInfo.businessTime) && <InfoIcon className="info-icon" aria-hidden="true"/>}
                </div>
            </div>
        </div>


    </CustomLink>
}

Method.propTypes = {
    method: PropTypes.string.isRequired,
    onClickCallback: PropTypes.func.isRequired,
    heading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    subHeading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    queryParams: PropTypes.string.isRequired,
    category: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    enabled: PropTypes.bool,
    disabledInfo: PropTypes.string,
    info: PropTypes.string
}

export default Method
